import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import { timeDurationToTime } from "../../utilities/utility";
import { NotificationManager } from "react-notifications";

export const Schedule = (props) => {

  const classes = useStyles();
  const [scheduleData, setScheduleData] = useState([]);

  useEffect(async () => {
    if (props.schedule["slot_times"] != undefined) {
      setScheduleData(props.schedule["slot_times"]);
    }
  }, [props.schedule]);

  const getDimScheduleColumnList = () => {
    return [
      {
        title: "Start Time",
        cellStyle: { whiteSpace: "nowrap", textAlign: "center" },
        // field: "onTime",
        render: ({ on_time: { hrs: hrs = 0, mins: mins = 0 } = { hrs: hrs = 0, mins: mins = 0 } }) => {
          return timeDurationToTime({ hrs: hrs, mins: mins });
        },
        exportTransformer: ({ on_time: { hrs: hrs = 0, mins: mins = 0 } = { hrs: hrs = 0, mins: mins = 0 } }) => {
          return timeDurationToTime({ hrs: hrs, mins: mins });
        }
      },
      {
        title: "End Time",
        cellStyle: { whiteSpace: "nowrap", textAlign: "center" },
        // render: ({ off_time: {hrs:hrs=0,mins:mins=0} = {hrs:hrs=0,mins:mins=0} }) => {
        render: (data) => {
          let time = null;
          if (data["off_time"] != undefined) {
            time = data["off_time"];
          }
          return timeDurationToTime(time);
        },
        exportTransformer: ({ off_time: { hrs: hrs = 0, mins: mins = 0 } = { hrs: hrs = 0, mins: mins = 0 } }) => {
          return timeDurationToTime({ hrs: hrs, mins: mins });
        }
      },
    ];
  };

  return (
    <div className="dim-schedule">
      <MaterialTable
        style={{
          // margin: "20px 0",
          width: "100%",
        }}
        className={classes.table}
        title={<div className="title">Schedule</div>}
        columns={getDimScheduleColumnList()}
        data={scheduleData}
        options={{
          exportButton: false,
          // grouping: true,
          search: false,
          selection: false,
          sorting: true,
          pageSize: 5,
          headerStyle: {
            backgroundColor: "#0071CE",
            color: "#FFF",
            fontSize: "0.9em",
            textAlign: "center",
          },
          actionsColumnIndex: -1,
          emptyRowsWhenPaging: false,
        }}
        actions={[
          {
            icon: 'edit',
            tooltip: 'Edit Schedule',
            onClick: (event, rowData) => {
              console.log(`Onclick Edit ${JSON.stringify(rowData)}`);
              props.OnClickEditSchedule(rowData);
            }
          },
          {
            icon: 'delete',
            tooltip: 'Delete Schedule',
            onClick: (event, rowData) => {
              console.log(`Onclick delete ${JSON.stringify(rowData)}`);
              props.OnClickDeleteSchedule(rowData);
            }
          },
          props.isUpdated != null && {
            icon: 'save',
            tooltip: 'Save Schedule',
            isFreeAction: true,
            onClick: (event) => {
              console.log("Onclick Save");
              if (props.isUpdated) {
                props.OnClickSaveSchedule(props.enableStatus);
              } else {
                NotificationManager.error("No chnages to save Dim Schedule", "", 3000);
              }
            }
          },
          {
            icon: 'add',
            tooltip: 'Add Schedule',
            isFreeAction: true,
            onClick: (event) => {
              console.log("Onclick add");
              props.OnClickAddSchedule();
            }
          }
        ]}
      />
    </div>
  );
}

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);